<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h4 font-weight-bold text-primary">GoZhere Mobile Apps</div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <MobileAppCard 
                        name="iPhone"
                        imgSrc="https://i.imgur.com/Ym7spqW.png"
                    />
                </b-col>
                <b-col>
                    <MobileAppCard 
                        name="Android"
                        imgSrc="https://i.imgur.com/WIU83kf.png"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    width: 100%;
}
</style>

<script>
import MobileAppCard from './MobileAppCard'

export default {
    components: {
        MobileAppCard
    }
}
</script>